// Global Instructions Rule Applied!

export const SET_FILTER_OPTIONS = 'deals/SET_FILTER_OPTIONS' as const
export const SET_DEALS = 'deals/SET_DEALS' as const
export const SET_ACTIVE_FILTERS = 'deals/SET_ACTIVE_FILTERS' as const
export const SET_ACTIVE_SORTING = 'deals/SET_ACTIVE_SORTING' as const
export const CLEAR_ACTIVE_FILTERS = 'deals/CLEAR_ACTIVE_FILTERS' as const
export const CLEAR_ACTIVE_SORTING = 'deals/CLEAR_ACTIVE_SORTING' as const
export const UPDATE_DEAL_RECORD = 'deals/UPDATE_DEAL_RECORD' as const
export const ADD_DEAL = 'deals/ADD_DEAL' as const
export const UPDATE_DEAL_ROUND = 'deals/UPDATE_DEAL_ROUND' as const
export const REMOVE_DEAL_FROM_LIST = 'deals/REMOVE_DEAL_FROM_LIST' as const
